import React from 'react'
import { classNames } from '@/shared/lib/utils/classNames'
import { ReactComponent as Slots } from '@/shared/assets/slots.svg'
import { ReactComponent as Game } from '@/shared/assets/game.svg'
import { ReactComponent as Browser } from '@/shared/assets/browser.svg'
import cls from './LobbyList.module.scss'


const LobbyItem = ({ icon, title, description }) => {
    return (
        <div className={cls.LobbyItem}>
            {icon}
            <h2>{title}</h2>
            <span>{description}</span>
        </div>
    )
}
export const LobbyList = ({ className }) => {
    const lobbyItems = [
        {
            icon: <Slots />,
            title: 'Lobby',
            description: 'User-friendly, intuitive,\n vibrant, and adaptive —\n the best interface\n imaginable.',
        },
        {
            icon: <Game />,
            title: 'Games',
            description:
                'Innovative, highly engaging,\n and uniquely popular game\n mechanics. We know what\n players want.',
        },
        {
            icon: <Browser />,
            title: 'Admin services',
            description:
                'Convenient, user-friendly, \nand comprehensive \ncontrol over metrics, \nfinancial flows, and \nreports.',
        },
        {
            icon: <Slots />,
            title: 'Lobby',
            description: 'User-friendly, intuitive,\n vibrant, and adaptive —\n the best interface\n imaginable.',
        },
        {
            icon: <Game />,
            title: 'Games',
            description:
                'Innovative, highly engaging,\n and uniquely popular game\n mechanics. We know what\n players want.',
        },
        {
            icon: <Browser />,
            title: 'Admin services',
            description:
                'Convenient, user-friendly, \nand comprehensive \ncontrol over metrics, \nfinancial flows, and \nreports.',
        },
    ]
    return (
        <article className={classNames(cls.LobbyList, [className])}>
            {lobbyItems.map((item) => (
                <LobbyItem
                    icon={item.icon}
                    title={item.title}
                    description={item.description}
                />
            ))}
        </article>
    )
}
